import {
  ChatModeDropdownContent,
  ChatModeDropdownRoot,
  ChatModeDropdownTrigger,
} from './chat-mode-dropdown.parts';

export const ModeDropdown = {
  Root: ChatModeDropdownRoot,
  Trigger: ChatModeDropdownTrigger,
  Content: ChatModeDropdownContent,
};
